// Feature 012: what the variant group modal and its create form share.
import {PeerActivityModeCode} from "../../../redux/Content/PeerActivityMode/types";

export type Translate = (key: string, defaultValue?: string) => string;

export interface ChannelOption {
    uuid: string;
    name: string;
    network: string;
    /** The kinds this channel takes; a channel without the list is offered for posts only. */
    modes?: string[];
    avatar?: string | null;
    /** The connector handler's uuid, which the networks' text limits are keyed by. */
    handlerUuid?: string;
}

/** A network's text limit for a channel, a kind of post, and whether the post carries media. */
export type LimitFor = (channel: ChannelOption, mode: string, hasMedia: boolean) => number | null;

export const VERSION_LABELS = ['A', 'B', 'C', 'D', 'E'];
export const MIN_VARIANTS = 2;
export const MAX_VARIANTS = 5;

export const takesMode = (channel: ChannelOption, mode: string): boolean =>
    (channel.modes ?? [PeerActivityModeCode.ACTIVITY as string]).includes(mode);

export const toLocalInput = (iso: string | Date): string => {
    const d = new Date(iso);
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const fromLocalInput = (value: string): string => new Date(value).toISOString();
